<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>LS</span>
        <span class="font-weight-light">Encuestas comedor</span>
        <v-btn v-if="$store.state.user" small text @click="logout">Salir</v-btn>
      </v-toolbar-title>
    </v-app-bar>

    <v-content class="light-green lighten-5">
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import firebase from "firebase";

export default {
  name: "App",
  data: () => ({
    //
  }),
  methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.state.user = null;
          this.$router.replace("/login");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
